module.exports = __webpack_public_path__ + "img/1510477196.2ed18878.jpg";